export default {
  metaTitle: '修改商品',
  pageTitle: '修改商品 -- Listing',
  currentCountry: '当前国别',
  selectCategory: '选择类目',
  selected: '已选择',
  information: '商品信息',
  productTitle: '商品标题',
  productShort: '商品简述',
  pCost: 'pCost',
  productPicture: '商品图片',
  sizeChartPicture: '尺码参考图',
  pleaseUploadSizeChart: '请上传尺码图',
  productVideo: '商品视频',
  s26_27M: '26秒,27M',
  reselect: '重新选择',
  tips1: '限制为30秒内，大小30M内',
  productType: '商品类型',
  radio1: '多SKU',
  radio2: '单SKU',
  style: '默认展示(Style)规格项值',
  radio3: '其他请输入',
  specifications: '选择规格',
  content1: 'Color规格通常用来描述外表差异',
  content2: 'Size规格通常用来展示外观或容量大小。比如服装的x,xl,xxl等等，又比如手机内存容量的32g,64g等等',
  content3: 'Style用于一些组合的规格或其它不适合用Size及Color来表达的规格',
  content4: '对于服装，如果只有颜色区别，请仅核查Color',
  content5: '对于手机，如果只有容量区别，请仅核查Size，如果有颜色和容量区别请检查Size和Color',
  content6: '诸如type-c转换器这类商品，有1托2，1托3，1托4，有的带有hdmi，有的带有网口，有的带有读卡器，这些自定义的规格请选对Style',
  size: 'Size',
  addSize: '添加自定义Size规格值',
  placeholder1: '在此输入',
  selectAddSize: '已选择或添加的Size规格值',
  color: 'Color',
  addColor: '添加自定义的Color值',
  selectAddColor: '已选择或添加的Color规格值',
  styles: 'Style',
  addStyle: '添加自定义的Style值',
  selectAddStyle: '已选择或添加的Style规格值',
  listSKU: 'SKU列表',
  onclick: '一键应用设置',
  listPrice: '市场指导价',
  salePrice: '售价',
  stock: '库存',
  vendorProductId: '供应商商品ID',
  checkbox1: '为未选择主图的SKU默认选择Listing下第一张图作为当前SKU主图',
  checkbox2: '为了提供卖家操作效率，我们增添了一健应用设置功能。可以在此区域输入listPrice,SalePrice,Stock,供应商商品ID等，点击一健应用 然后输入到上方sku列表区域中。通常库存、供应商商品ID对于每个SKU而言都是不同的，我们并不建议您批量应用此两处设置(通常适用于虚拟库存的情况)。',
  apy: '一键应用',
  transportation: '运输相关信息',
  grossWeight: '商品毛重',
  withBattery: '带电',
  partially: '部分',
  withMagnetic: '含磁',
  powder: '带粉',
  compressionAgent: '含压缩剂',
  content7: '请填写上述信息',
  otherInformation: '其它信息',
  selectStoreCategory: '请选择店内分类',
  productDetails: '商品信息(图文详情描述)',
  selectWarehouse: '选择仓库',
  settingWarehouse: '仓库支付设置',
  pay1: '在线支付',
  pay2: '货到付款',
  payMethod: '支付方式',
  online: '在线支付',
  publishOptions: '发布选项',
  radio4: '保存并上架',
  radio5: '仅保存',
  radio6: '以当前状态保存',
  first: '3C',
  column1: 'Size',
  column2: 'Color',
  column3: 'Style',
  column4: '市场指导价',
  column5: '售价',
  column6: 'pCost',
  column7: 'pCost',
  column8: '供应商商品ID',
  column9: '库存',
  column10: '标记',
  column11: '操作',
  column12: '主图',
  marks1: '已标记删除',
  marks2: '取消删除标记',
  choose: '选择',
  error1: '您尚未应用任意项，未能执行',
  error2: '最多可以上传5张图片',
  error3: '请上传JPG/GIF/PNG类型的图片',
  error4: '文件过大，单个文件上限为2M',
  // info1: '最多上传10张主图',
  infoa: '最多上传',
  infob: '张主图',
  error5: '视频时长在30秒以内',
  error6: '请上传mp4格式的视频',
  error7: '视频大小在30M以内',
  warning1: '此规格值已存在',
  error8: '请填写商品标题',
  error9: '请上传图片',
  error10: '请上传SKU',
  error11: '请填写商品毛重',
  error12: '请选择支付设置',
  error13: '请选择仓库',
  error14: '请选择店内分类',
  error15: '请填写库存',
  error16: '请选择主图',
  error17: '销售价价格不能为0',
  error18: '价格不能为0',
  error19: '销售价不能大于List Price',
  error20: '至少选择一种规格',
  success1: '成功',
  successOk: '确认',
  error21: '此商品不支持全功能编辑',
  info2: '一次最多只能上传10个文件',
  taxClass: 'Tax class',
  customCodeName: '海关商品名',
  customCode: '海关编码',
  customCodeAttribute: '商品申报要素',
  isItFragile: 'Is it fragile',
  youNotKeepActiveOnline: '当该商品所有SKU都下架时，您不能以上架状态或保持上架状态提交保存。',
  wgUnlock: '本商品已违规下架，请先提交管理员审核上架。',
  youNotKeepInactiveOnline: '当该商品有部分SKU是上架时,您不能以下架状态或保持下架状态提交保存',
  customCodeNameCN: '中文品名',
  customDeclaredValueCNY: '申报价值(元人民币)',
  applyToChangeCategory: '申请修改品类',
  changeLog: '修改日志',
  id: 'ID',
  originalCategory: '原始品类',
  changedCategory: '修改品类',
  status: '状态',
  applyDate: '申请日期',
  auditDate: '审核日期',
  operation: '操作',
  inReview: '待审核',
  approved: '已审核',
  rejected: '已拒绝',
  canceled: '已取消',
  cancel: '取消',
  sureCancelOperation: '确定执行取消操作吗？',
  confirm: '确认',
  cancelSuccess: '取消成功',
  changeCategory: '修改品类',
  remainingChances: '修改次数',
  current: '当前',
  changeTo: '修改为',
  changingCategoriesMayLosses: '更改类别可能导致以下风险或损失:',
  instructions1: '1. 产品权重将重新计算，这可能会暂时影响产品排名;',
  instructions2: '2. 产品信息质量得分将重新计算，这可能会影响产品排名;',
  instructions3: '3. 可触发新品类下的质量控制审查.',
  confirmToChange: '确认修改',
  currentSameAsChangeTo: '当前品类与修改品类相同，请选择不同的品类。'
}
